module.exports = __webpack_public_path__ + "static/04-thumb-793332a170ab36ccb5e80cddb6d3dd53.jpg";